module.exports = __webpack_public_path__ + "static/media/icon-magnet-score.bf8dcbb4.svg";